import { Observable } from 'rxjs'

/**
 * Creates an Observable from a Server-Sent Events (SSE) endpoint.
 *
 * @param url The SSE endpoint URL
 * @param options Optional configuration options
 * @returns An Observable that emits messages
 */
export function connectToSSE<T>(url: string): Observable<MessageEvent<T>> {
  return new Observable<MessageEvent<T>>((observer) => {
    const eventSource = new EventSource(url)

    eventSource.onmessage = (message: MessageEvent<T>) => {
      observer.next(message)
    }

    eventSource.onerror = (err: unknown) => {
      console.error('EventSource error', err)
      observer.error(err)
    }

    return () => {
      eventSource.close()
    }
  })
}
